<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/web/print/record/page" ref="yt" getKey="rows" :columns="columns"> </yi_curd_table>
  </div>
</template>

<script>
export default {
  name: 'web_material_management_mixture_print_log',
  props: {
    // 父组件传过来的参数
    mixtureOrderId: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      columns: [
        {
          label: 'dayinshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'biaoqiantiaoma',
          prop: 'labelBarcodeNumber'
        },
        {
          label: 'shuliang',
          prop: 'packageNumber'
        },
        {
          label: 'dayinren',
          prop: 'createByObject.nickname'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.orderId = this.mixtureOrderId;
      this.yt.conditions.businessTypes = 13;
      this.yt.conditions.notSearchFlag = false;
      this.yt.conditions.orderBy = 'createTime desc';
      this.yt.get(1);
    }, 300);
  }
};
</script>

<style scoped lang="scss"></style>
